import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CommerrorService } from './commerror.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
  constructor(private ce: CommerrorService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authReq = req.clone({
      setHeaders: {
        'X-App-Version': environment.appVersion,
      },
    });
    // The Support Center widget handles its own failures; its background calls must neither
    // pop the global error box nor clear an error the user hasn't read yet.
    if (req.url.startsWith('/api/support-center')) return next.handle(authReq);

    return next.handle(authReq).pipe(
      tap(
        (data) => {
          this.ce.clearCommError();
        },
        (error) => {
          this.ce.handleCommError(error);
        }
      ) //,
      //catchError(this.handleError),
    );
  }
}
